module.exports = __webpack_public_path__ + "img/2.c5562f5.jpg";